export const CLUB_SELECTORS = {
  modalMount: '.vue-club-modal-info',
  serviceDiscountControlMount: '.vue-club-service-discount-control',
  infoDetailBannerMount: '.vue-club-info-detail-banner',
  priceWithDiscount: '[data-price-is-club-default="true"]',
  priceWithoutDiscount: '[data-price-is-club-default="false"]',
}

export const CLUB_DATA_STORE = {
  isEnabledLpu: 'data-club-is-enabled-lpu',
  componentContextProps: 'data-club-context-props',
}
